import { useState } from 'react';
import SuppliesApi from '../../../../API/shipment/supplies-api';
import { Column, PopUp, Row } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { DateInput, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { H2 } from '../../../../components/Basic/WrapsStyle';
import { MARKETS_ALL, MARKETS_MAP, TYPE_BUTTONS, WAREHOUSE_LIST } from '../../../../constans';
import styles from './styles.module.scss';


const CreateSupplyPopUp = ({ close = () => { } }) => {
  const [data, setData] = useState({
    time_scheduled: null,
    info: '',
    market: 'wb',
    shop: '',
    sklad: WAREHOUSE_LIST[0],
  });
  // const [market, setMarket] = useState('wb');
  // const [shop, setShop] = useState();
  // const [sklad, setSklad] = useState(WAREHOUSE_LIST[0]);

  const validate = () => {
    return data.time_scheduled;
  };

  const clickAdd = () => {
    if (validate()) {
      SuppliesApi.createSupply({ data: { market: data.market.toLowerCase(), shop: MARKETS_MAP[data.shop], time_scheduled: data.time_scheduled, skladName: data.sklad?.name } }).then((r) => {
        close();
      });
    }
  };

  // useEffect(() => {
  // setMarket(Object.keys(MARKETS_ALL)[0]);
  // }, []);

  // useEffect(() => {
  //   if (market) {
  //     setShop(MARKETS_ALL[market][0]);
  //   }
  //   if (market === 'Sber' || market === 'Wb') {
  //     setIsExpress(LIST_EXPRESS[0]);
  //   }
  // }, [market]);

  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>Добавить новую поставку</H2>
      <Row>
        <div style={{ marginRight: '25px' }}>
          <Select
            list={Object.keys(MARKETS_ALL)}
            select={data.market}
            label="Площадка"
            onSelect={(v) => setData({ ...data, market: v })}
            width={'150px'}
          />
        </div>
        <div style={{ marginRight: '25px' }}>
          <Select
            list={MARKETS_ALL['wb']}
            select={data.shop}
            label="Магазин"
            onSelect={(v) => setData({ ...data, shop: v })}
            width={'150px'}
          />
        </div>

      </Row>
      <Row style={{ marginTop: '20px' }}>
        <Column style={{ marginRight: '25px', width: '150px' }}>
          <InputLabel style={{ marginTop: '3px', }}>Дата поставки</InputLabel>
          <DateInput onChange={(v) => setData({ ...data, time_scheduled: v })} />
        </Column>
        <div>
          <Select
            list={WAREHOUSE_LIST}
            select={data.sklad}
            label="Склад отгрузки"
            valueFn={(v) => v.warehouse}
            onSelect={(v) => setData({ ...data, sklad: v })}
            width={'150px'}
          />
        </div>
      </Row>


      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          disabled={!data.time_scheduled || !data.shop}
          style={{
            marginRight: '15px',
          }}
          onClick={!data.time_scheduled ? () => { } : clickAdd}
        >
          Добавить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отменить
        </Button>
      </Row>
    </PopUp>
  );
};

export default CreateSupplyPopUp;
